export const COMPANY = {
  name: "Esprit Home Healthcare",
  phone: "(703) 998-7400",
  phoneHref: "tel:+17039987400",
  afterHours: "(703) 998-7400",
  fax: "(703) 998-6700",
  email: "info@esprithomecare.com",
  gbp: "https://www.google.com/maps?cid=17735345986771970042",
  directions: "https://www.google.com/maps/dir/?api=1&destination=Esprit%20Home%20Healthcare%2C%204209%20Evergreen%20Lane%2C%20Annandale%2C%20VA%2022003",
  address1: "4209 Evergreen Lane, Suite 101",
  address2: "Annandale, VA 22003",
  tagline: "Compassionate Care, Right at Home.",
  hours: [
    { day: "Mon", time: "8:30 AM – 5:30 PM" },
    { day: "Tue", time: "8:30 AM – 5:30 PM" },
    { day: "Wed", time: "8:30 AM – 5:30 PM" },
    { day: "Thu", time: "8:30 AM – 5:30 PM" },
    { day: "Fri", time: "8:30 AM – 5:30 PM" },
    { day: "Sat", time: "Closed (On Call)" },
    { day: "Sun", time: "Closed (On Call)" },
  ],
};

export const SERVICE_OPTIONS = [
  "In-Home Nursing Care",
  "Physical / Occupational / Speech Therapy",
  "Medical Social Worker Services",
  "Personal Care / Private Duty Aide",
  "Assistance with Activities of Daily Living",
  "Job Opportunities",
  "Other",
];

export const HEARD_OPTIONS = [
  "Google / Online Search",
  "Friend or Family",
  "Doctor or Hospital Referral",
  "Insurance Provider",
  "Social Media",
  "Returning Client",
  "Other",
];

export const SERVICE_AREAS = [
  "Annandale", "Fairfax", "Arlington", "Alexandria", "Falls Church",
  "Vienna", "McLean", "Springfield", "Burke", "Centreville",
  "Reston", "Herndon", "Tysons", "Chantilly", "Fairfax Station", "Lorton",
];

export const LISTINGS = [
  { name: "Google", url: "https://www.google.com/maps?cid=17735345986771970042" },
  { name: "Yelp", url: "https://www.yelp.com/biz/esprit-home-care-annandale-2" },
  { name: "Care.com", url: "https://www.care.com/b/l/esprit-homecare-llc/falls-church-va" },
  { name: "LinkedIn", url: "https://www.linkedin.com/company/esprit-home-healthcare-llc/" },
  { name: "MapQuest", url: "https://www.mapquest.com/us/virginia/esprit-home-care-llc-381049638" },
  { name: "CareListings", url: "https://carelistings.com/home-health-agencies/annandale-va/esprit-home-healthcare-llc/5ace891593efd2372f991d55" },
  { name: "SeniorCare", url: "https://www.seniorcare.com/home-care/va/annandale/esprit-home-health-care/8417/" },
  { name: "ZoomInfo", url: "https://www.zoominfo.com/c/esprit-home-healthcare-llc/95391763" },
];

export const IMG = {
  hero: "/img/care-1.png",
  about: "/img/care-5.png",
  therapy: "/img/care-2.png",
  personal: "/img/care-3.png",
  home: "/img/care-4.png",
};
